import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export default function DataTableDraggable(props) {
  let {
    columns,
    data,
    equalWidth,
    miniHeader,
    miniRow,
    rowSelection,
    isRowSelected,
    selectableRow,
    rowKey,
    cookieName,
  } = props;
  const [listedColumns, setListedColumns] = useState([]);
  const [cols, setCols] = useState([]);
  const [dragOver, setDragOver] = useState("");

  const [listedData, setListedData] = useState(data);

  // gelen data değişirse rerender etmeli
  useEffect(() => {
    let listed = JSON.parse(JSON.stringify(data));
    listed.sort((a, b) => {
      return b.id - a.id;
    });
    setListedData(listed);
  }, [data]);

  useEffect(() => {
    let columnCookie = cookies.get(cookieName);
    if (!columnCookie) {
      setCols(
        columns.map((item) => {
          return item.key;
        })
      );
    } else {
      setCols(columnCookie);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let lColumns = cols.reduce((acc, value) => {
      acc.push(
        columns.find((item) => {
          return item.key === value;
        })
      );
      return acc;
    }, []);
    setListedColumns(lColumns);
    // eslint-disable-next-line
  }, [cols]);

  const rowClick = (e, row) => {
    // row selectable değilse devam etmemeli,
    if (!selectableRow) return;
    // row'un içinde TD harici herhangi bir elamana (input, button vb.) tıklanırsa rowSelection çalışmamalı
    if (e.target.tagName !== "TD") return;
    rowSelection(row);
  };
  const rowSelected = (row) => {
    // row selectable değilse devam etmemeli,
    if (!selectableRow) return;
    return isRowSelected(row);
  };

  // drag drop functions
  const handleDragStart = (e) => {
    const { id } = e.target;
    const idx = cols.indexOf(id);
    e.dataTransfer.setData("colIdx", idx);
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleDragEnter = (e) => {
    const { id } = e.target;
    setDragOver(id);
  };

  const handleOnDrop = (e) => {
    const { id } = e.target;
    const droppedColIdx = cols.indexOf(id);
    const draggedColIdx = e.dataTransfer.getData("colIdx");
    // deep copy
    const tempCols = JSON.parse(JSON.stringify(cols));
    setCols(move(tempCols, draggedColIdx, droppedColIdx));
    cookies.set(cookieName, tempCols, {
      maxAge: 99999999999,
      httpOnly: true,
      secure: true,
    });
    setDragOver("");
  };
  const move = (arr, moveEle, moveToIndx) => {
    // If acctual index of moved element is
    // less than 0 when 'moveEle += array size'
    while (moveEle < 0) {
      moveEle += arr.length;
    }

    // Where the element to be moved f that
    // index is less than 0 when
    // 'moveToIndx += array size'
    while (moveToIndx < 0) {
      moveToIndx = moveToIndx + arr.length;
    }

    // If 'moveToIndx' is greater than the
    // size of the array then with need to
    // push 'undefined' in the array.
    if (moveToIndx >= arr.length) {
      let un = moveToIndx - arr.length + 1;
      while (un--) {
        arr.push(undefined);
      }
    }
    let moveFixer = 0;
    if (moveToIndx > moveEle) {
      moveFixer = 1;
    }
    // Here element of 'moveEle' is removed and
    // pushed at 'moveToIndx' index
    arr.splice(moveToIndx - moveFixer, 0, arr.splice(moveEle, 1)[0]);

    return arr;
  };

  return (
    <div
      className={`km__c--table ${
        equalWidth ? "km__c--table-is-equalwidth" : ""
      }`}
    >
      <div className="km__c--table-container">
        <table>
          <thead className={`${miniHeader ? "km__c-table-mini-header" : ""}`}>
            <tr>
              {listedColumns.map((item) => {
                return (
                  <th
                    id={item.key}
                    key={item.selector + "-" + item.key}
                    width={item.width}
                    draggable
                    onDragStart={handleDragStart}
                    onDragOver={handleDragOver}
                    onDrop={handleOnDrop}
                    onDragEnter={handleDragEnter}
                    style={
                      item.key === dragOver
                        ? { borderLeft: "2px solid #0065FF" }
                        : {}
                    }
                  >
                    {item.name}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody
            className={`
              ${miniRow ? "km__c-table-mini-row" : ""}
              ${selectableRow ? " km__c-table-has-selectable-row" : ""}
            `}
          >
            {listedData.map((dataItem) => {
              return (
                <tr
                  key={dataItem[rowKey]}
                  onClick={(e) => rowClick(e, dataItem)}
                  className={`${
                    rowSelected(dataItem)
                      ? " km__c-table-has-selectable-row-is-selected"
                      : ""
                  }`}
                >
                  {listedColumns.map((columnItem) => {
                    return (
                      <td
                        key={`${dataItem[rowKey]}-${columnItem.selector}-${columnItem.key}`}
                        title={dataItem[columnItem.selector]}
                      >
                        {/* özel renderlanacak olan bir cell varsa onu renderlar yoksa gelen value'yu renderlar */}
                        {columnItem.cell
                          ? columnItem.cell(dataItem)
                          : dataItem[columnItem.selector]}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
DataTableDraggable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  equalWidth: PropTypes.bool,
  miniHeader: PropTypes.bool,
  miniRow: PropTypes.bool,
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
DataTableDraggable.defaultProps = {
  columns: [],
  data: [],
  equalWidth: false,
  miniHeader: false,
  miniRow: false,
  rowKey: "id",
};
